import React from "react";
import { Sparkles } from "lucide-react";

const OfferStrip = () => (
    <div
        className="w-full text-[color:var(--ivory)] text-[11px] font-ui tracking-widest-x uppercase py-2.5 relative overflow-hidden"
        style={{ background: "linear-gradient(90deg, #5C1420 0%, #7B1E2B 50%, #5C1420 100%)" }}
        data-testid="offer-strip"
    >
        <div className="container-x flex items-center justify-center gap-3 relative">
            <Sparkles size={13} className="text-[color:var(--gold)]" strokeWidth={1.4} />
            <span className="hidden sm:inline text-[color:var(--gold)]">Festive Season</span>
            <span className="opacity-70 hidden sm:inline">·</span>
            <span className="text-center">Flat 15% off on all Bridal Sets <span className="hidden sm:inline">·</span><br className="sm:hidden" /> Code <span className="text-[color:var(--gold)]">Kanganya15</span></span>
            <span className="opacity-70 hidden md:inline">·</span>
            <span className="hidden md:inline">Free Shipping across India</span>
        </div>
    </div>
);

export default OfferStrip;
